


























































































































































import { Component } from "vue-property-decorator";
import ajax from "../../../lib/ajax";
import AbpBase from "../../../lib/abpbase";
import { Workbook } from "exceljs";

interface QueryStatistic {
  refId: number;
  referrerId: string;
  queryCount: number;
}

interface MetaSearchDestinationDetail {
  destination: string;
  count: number;
}

type MetaSearchStatsItem = {
  referrerId: string;
  totalSearches: number;
  destinations: MetaSearchDestinationDetail[];
};

interface MetaSearchStatsResponse {
  // API bazen dizi döndürüyor, bazen tek nesne olabilir
  result: MetaSearchStatsItem | MetaSearchStatsItem[];
  success: boolean;
  error: any;
}

interface ApiResponse {
  result: {
    statistics: QueryStatistic[];
    fromDate: string;
    toDate: string;
    totalQueries: number;
  };
  success: boolean;
  error: any;
}

@Component({})
export default class QueryStatistics extends AbpBase {
  dateMenu = false;
  selectedDate = new Date().toISOString().substr(0, 10);
  loading = false;
  hasSearched = false;
  statistics: QueryStatistic[] = [];
  totalQueries = 0;
  detailDialog = false;
  detailLoading = false;
  selectedReferrerId: string | null = null;
  metaStats: MetaSearchStatsItem | null = null;

  headers = [
    { text: "Ref ID", value: "refId", sortable: true },
    { text: "Referrer ID", value: "referrerId", sortable: true },
    { text: "Sorgu Sayısı", value: "queryCount", sortable: true },
    { text: "İşlemler", value: "actions", sortable: false, align: "end" },
  ];

  detailHeaders = [
    { text: 'Rota', value: 'destination' },
    { text: 'Sorgu Sayısı', value: 'count' }
  ];

  breadcrumbsItems = [
    {
      text: "Ana Sayfa",
      disabled: false,
      href: "/main/home",
    },
    {
      text: "Sorgu Sayıları",
      disabled: true,
    },
  ];

  get getFormattedDate() {
    if (!this.selectedDate) return "";
    const date = new Date(this.selectedDate);
    return date.toLocaleDateString("tr-TR");
  }

  getQueryCountColor(count: number): string {
    if (count > 100000) return "red";
    if (count > 50000) return "orange";
    if (count > 10000) return "yellow darken-2";
    if (count > 1000) return "green";
    return "blue";
  }

  async loadStatistics() {
    this.loading = true;
    this.hasSearched = true;

    try {
      const response = await ajax.get<ApiResponse>(
        `/api/services/app/Admin/GetDailySearchStatistics?date=${this.selectedDate}`
      );

      if (response.data.success && response.data.result) {
        this.statistics = response.data.result.statistics;
        this.totalQueries = response.data.result.totalQueries;
      } else {
        this.statistics = [];
        this.totalQueries = 0;
        this.$swal({
          icon: "error",
          title: "Hata",
          text: "Veriler yüklenirken bir hata oluştu",
        });
      }
    } catch (error) {
      this.statistics = [];
      this.totalQueries = 0;
      console.error("Error loading statistics:", error);
    } finally {
      this.loading = false;
    }
  }

  onRowClick(item: QueryStatistic) {
    this.openDetails(item);
  }

  async openDetails(item: QueryStatistic) {
    this.detailDialog = true;
    this.detailLoading = true;
    this.selectedReferrerId = item.referrerId;
    this.metaStats = null;

    try {
      const response = await ajax.get<MetaSearchStatsResponse>(
        "/api/services/app/Admin/GetMetaSearchStats",
        {
          params: {
            referrerId: item.referrerId,
            date: this.selectedDate,
          },
        }
      );

      if (response.data.success && response.data.result) {
        const res = response.data.result as MetaSearchStatsItem | MetaSearchStatsItem[];
        if (Array.isArray(res)) {
          this.metaStats = res.find(r => r.referrerId === item.referrerId) || res[0] || null;
        } else {
          this.metaStats = res;
        }
      } else {
        this.$swal({
          icon: "error",
          title: "Hata",
          text: "Detay verileri yüklenemedi",
        });
      }
    } catch (error) {
      console.error("Error loading meta search stats:", error);
      this.$swal({ icon: "error", title: "Hata", text: "Detay verileri alınamadı" });
    } finally {
      this.detailLoading = false;
    }
  }

  async exportDetailsToExcel() {
    if (!this.metaStats) return;

    const wb = new Workbook();
    const ws = wb.addWorksheet("Detay");

    // Header info
    ws.addRow(["Referrer ID", this.metaStats.referrerId]);
    ws.addRow(["Tarih", this.getFormattedDate]);
    ws.addRow(["Toplam Sorgu", this.metaStats.totalSearches]);
    ws.addRow([]);

    // Table header
    ws.addRow(["Rota", "Sorgu Sayısı"]);
    const headerRow = ws.getRow(5);
    headerRow.font = { bold: true } as any;

    // Data rows
    this.metaStats.destinations.forEach((d) => {
      ws.addRow([d.destination, d.count]);
    });

    // Autosize columns
    const colCount = 2;
    for (let i = 1; i <= colCount; i++) {
      let maxLength = 10;
      ws.eachRow((row, rowNumber) => {
        const cell = row.getCell(i);
        const val = cell.value as any;
        const text = typeof val === "object" && val && "richText" in val ?
          (val.richText as any[]).map((rt: any) => rt.text).join("") :
          (val !== null && val !== undefined ? String(val) : "");
        if (text.length > maxLength) maxLength = text.length;
      });
      ws.getColumn(i).width = Math.min(Math.max(maxLength + 2, 12), 40);
    }

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `MetaSearch_${this.selectedReferrerId || "detay"}_${this.selectedDate}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  mounted() {
    this.loadStatistics();
  }
}
